<template> 
  <base-layout>
    <ul class="nav navbar-nav navbar-left" slot="toolbar_buttons">
      <li>
        <date-range-picker :allowFieldSelection="true" :dateFields="dateFields" :datesRange="datesRange" @dates-range-updated="updatedDates"></date-range-picker>
      </li>
    </ul>      
    
    <!-- slot main -->
    
    <div id="dashboard-canvas" class="col-xs-12 main with-leads-table with-leads-table-active" slot="main">
      <!-- components -->
      <div class="row ls-charts">
          <h1>Policies</h1>
          <div class="pivots-wrapper">
              <span class="pivot label" v-if="pivot_branch_options.length">
                  Branch: <button @click="showBranchOptions=!showBranchOptions"><span class="badge badge-success">{{ countPivots(pivots.branch_code) }}</span></button>
                  <div v-show="showBranchOptions" class="pivot-select-wrapper">
                      <header>
                          <button class="btn btn-link" @click="toggleBranchOptions">
                              <span v-if="pivots.branch_code.length">Unselect all</span>
                              <span v-else>Select all</span>
                          </button>
                      </header>
                      <select multiple v-model="pivots.branch_code" size="10">
                          <option v-for="p in pivot_branch_options" :value="p[0]">{{ p[1] }}</option>
                      </select>
                  </div>
              </span>
              <span class="pivot label" v-if="pivot_type_options.length">
                  Policy Type: <button @click="showTypeOptions=!showTypeOptions"><span class="badge badge-success">{{ countPivots(pivots.policy_type_code) }}</span></button>

                  <div v-show="showTypeOptions" class="pivot-select-wrapper">
                      <header>
                          <button class="btn btn-link" @click="toggleTypeOptions">
                              <span v-if="pivots.policy_type_code.length">Unselect all</span>
                              <span v-else>Select all</span>
                          </button>
                      </header>
                      <select multiple v-model="pivots.policy_type_code" size="10">
                          <option v-for="p in pivot_type_options" :value="p[0]">{{ p[1] }}</option>
                      </select>
                  </div>
              </span>
          </div>
          
          <div class="row">
              <div class="box">
                  <ls-metric-banner class="col-lg-6 col-xs-12" v-bind:series="summary"></ls-metric-banner>
              </div>
          </div>
          
          <div class="row">
              <div class="box">
                  <h2>Branches</h2>
              </div>
              
              <div class="col-xs-12 col-lg-6">
                  <div class="box">
                      <div class="panel">
                          <div class="panel-header">
                              <h3>Policies by Branch</h3>
                          </div>
                          <div class="panel-body">
                              <div class="col-xs-12 chart-wrapper">
                                  <ls-chart target-css-classes="chart" 
                                            :target-id="'by_branch'"
                                            v-bind:bc-data="stats.chart_by_branch.series" 
                                            v-bind:bc-layout="stats.chart_by_branch.layout">
                                  </ls-chart>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="col-xs-12 col-lg-6">
                  <div class="box">
                      <div class="panel">
                          <div class="panel-header">
                              <h3>Premiums by Branch</h3>
                          </div>
                          <div class="panel-body">
                              <div class="col-xs-12 chart-wrapper">
                                  <ls-chart target-css-classes="chart" 
                                            :target-id="'premium_by_branch'"
                                            v-bind:bc-data="stats.premium_by_branch.series" 
                                            v-bind:bc-layout="stats.premium_by_branch.layout">
                                  </ls-chart>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              
              <div class="col-xs-12 col-lg-6">
                  <div class="box">
                      <div class="panel">
                          <div class="panel-header">
                              <h3>Commissions by Branch</h3>
                          </div>
                          <div class="panel-body">
                              <div class="col-xs-12 chart-wrapper">
                                  <ls-chart target-css-classes="chart" 
                                            :target-id="'commission_by_branch'"
                                            v-bind:bc-data="stats.commission_by_branch.series" 
                                            v-bind:bc-layout="stats.commission_by_branch.layout">
                                  </ls-chart>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              
          </div>

          <div class="row">
              <div class="box">
                  <h2>Policy Types</h2>
              </div>
              
              <div class="col-xs-12 col-lg-6">
                  <div class="box">
                      <div class="panel">
                          <div class="panel-header">
                              <h3>Policies by Type</h3>
                          </div>
                          <div class="panel-body">
                              <div class="col-xs-12 chart-wrapper">
                                  <ls-chart target-css-classes="chart" 
                                            :target-id="'by_type'"
                                            v-bind:bc-data="stats.chart_by_type.series" 
                                            v-bind:bc-layout="stats.chart_by_type.layout">
                                  </ls-chart>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="col-xs-12 col-lg-6">
                  <div class="box">
                      <div class="panel">
                          <div class="panel-header">
                              <h3>Premiums by Type</h3>
                          </div>
                          <div class="panel-body">
                              <div class="col-xs-12 chart-wrapper">
                                  <ls-chart target-css-classes="chart" 
                                            :target-id="'premium_by_type'"
                                            v-bind:bc-data="stats.premium_by_type.series" 
                                            v-bind:bc-layout="stats.premium_by_type.layout">
                                  </ls-chart>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="col-xs-12 col-lg-6">
                  <div class="box">
                      <div class="panel">
                          <div class="panel-header">
                              <h3>Commissions by Type</h3>
                          </div>
                          <div class="panel-body">
                              <div class="col-xs-12 chart-wrapper">
                                  <ls-chart target-css-classes="chart" 
                                            :target-id="'commission_by_type'"
                                            v-bind:bc-data="stats.commission_by_type.series" 
                                            v-bind:bc-layout="stats.commission_by_type.layout">
                                  </ls-chart>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

          </div>
          <div class="col-xs-12">
              <div class="box">
                  <div class="panel">
                      <policies-table v-bind:pivots="pivots" v-bind:datesRange="datesRange" @loaded="refreshData"></policies-table>
                  </div>
              </div>
          </div>
      </div>
    </div>
    
    <div slot="modals">
      
    </div>
  </base-layout>
</template>

<script>
 /**
  * https://github.com/jbaysolutions/vue-grid-layout
  */
 import Vue from 'vue';

 import {BaseLayout} from 'components/layouts/';
 import DateRangePicker from 'components/elements/DateRangePicker';
 import PoliciesTable from 'components/elements/PoliciesTable';
 import LsChart from 'components/elements/PlotlyJS/LSBasicChart';
 import LsStatsTable from 'components/elements/LsStatsTable';
 import LsMetricBanner from 'components/elements/LsMetricBanner';
 
 // Load the full build. 
 var _ = require('lodash');

 export default {
   components: {
       BaseLayout,
       LsChart,
       DateRangePicker,
       PoliciesTable,
       LsStatsTable,
       LsMetricBanner
   },
   data () {
       return {
           count: null,
           showBranchOptions: false,
           showTypeOptions: false,
           pivot_branch_options: [],
           pivot_type_options: [],
           stats: {
               by_branch: [],
               by_type: [],
               billed: {
                   sum_billed_premium: null,
                   sum_billed_commission: null
               },
               chart_by_branch: {
                   series: [],
                   layout: {}
                   
               },
               commission_by_branch: {
                   series: [],
                   layout: {}
                   
               },
               premium_by_branch: {
                   series: [],
                   layout: {}
                   
               },
               chart_by_type: {
                   series: [],
                   layout: {}
                                  
               },
               commission_by_type: {
                   series: [],
                   layout: {}
                   
               },
               premium_by_type: {
                   series: [],
                   layout: {}
                   
               }
           },
           pivots: {
               branch_code: [],
               policy_type_code: []
           },
           datesRange: {
               from: moment().subtract(29, "days").format("YYYY-MM-DD"),
               to: null,
               date_field: null
           },
           pagination: {
	       current_page: 1, // required
           },
           dateFields: [{ id: '', value: '', name: 'Active policies', label: 'Active policies' }],
       };
   },
     
     computed: {
         pickedBranches: function () {
             if (this.pivots.branch_code) {
                 return this.pivots.branch_code.join(', ');
             }
             return '<i>None</i>';
         },
         summary: function () {
             let formatter = new Intl.NumberFormat('en-US', {
                 style: 'currency',
                 currency: 'USD'
             });
             
             return [
                 { name: 'Total Policies', value: this.count },
                 { name: 'Total Billed Premiums',
                   value: formatter.format(this.stats.billed.sum_billed_premium) },
                 { name: 'Total Billed Commissions',
                   value: formatter.format(this.stats.billed.sum_billed_commission) },                 
             ];
         }
         
     },
     watch: {
   
   },
   created () {
     var u = this.$store.state.user;
   }, 
     methods: {
         toggleBranchOptions () {
             if (this.pivots.branch_code.length) {
                 this.pivots.branch_code = [];
             }
             else {
                 this.pivots.branch_code = this.pivot_branch_options.map(
                     (o) => o[0]
                 );
             }
         },
         toggleTypeOptions () {
             if (this.pivots.policy_type_code.length) {
                 this.pivots.policy_type_code = [];
             }
             else {
                 this.pivots.policy_type_code = this.pivot_type_options.map(
                     (o) => o[0]
                 );
             }
         },
         countPivots(items) {
             if (!items) {
                 return '0 items';
             }
             let count = items.length;
             if (count == 1) {
                 return '1 item';
             }
             return count + ' items';
         },
     refreshData(data) {
         this.stats = data.stats;
         this.count = data.count;
         this.pivot_branch_options = data.pivots.branch_code;
         this.pivot_type_options = data.pivots.policy_type_code;
         this.dateFields = [{id: '', value: '', label: 'Active policies', name: 'Active policies'}]
                               .concat(data.date_fields.map( (f) => { return { id: f, value: f, label: f, name: f} }));
     },
     updatedDates: _.debounce(function (datesRange) {
       this.datesRange = datesRange;
//       Vue.set(this, 'datesRange', datesRange);
     }),
   }
 }
</script>

<style lang="scss" scoped>
 .pivot-select-wrapper {
     position: absolute;
     z-index: 1000;
     background: #efefef;
     padding: .4rem;
     box-shadow: 0px 3px 5px #bbb;
     border-radius: 0px 0px 4px 0px;
     margin-top: .4rem;
     min-width: 10rem;

     header {
         width: 100%;
         color: #333;
         margin-bottom: .4rem;
     }
     
     select {
         width: 100%;
         border-radius: 4px 4px 4px 4px;
         border: 1px solid #aaa;
     }
 }
 .dashboard-header {
   color: #ddd;
   border-bottom: 1px solid #ddd;
   margin-bottom: 4px;
   padding: 0px;
 }
 .dashboard-header .btn-group {
   display: inline-block;
   margin-top: 3px;
 }
 3.dashboard-header .col-xs-10,
 .dashboard-header .col-xs-2 {
   padding-left: 3px;
   padding-right: 3px;
 }
 .dashboard-header h3 {
   color: #ddd;
   font-size: 14pt;
 }
 .dashboard-header .btn-default {
   color: #ddd!important;
   border: 0px;
   border-radius: 0px;
   background: transparent;
 }
 .dashboard-header .btn-default:hover,
 .dashboard-header .btn-default:focus,
 .dashboard-header .btn-default:active {
   border: 0px;
   background: #aeaeae;
   shadow-box: 0;
   color: #555!important;
 }

 .empty-msg {
   margin: 30px auto;
 }


 /* Leads Queue styles */
 h1 .btn {
   background-color: transparent;
   margin-top: -8px;
 }

 h1 input {
   background: #fff;
   border: 0px!important;
   padding: 0px;
   padding-top: 4px;
   margin-top: -4px;
 }

 .leads-queue {
   padding: 0px!important;
   border: 1px solid #999;
   border-bottom: 0px;
   margin: 0px!important;
   float: none;
 }

 .leads-queue .chart-wrapper {
   padding: 0px!important;
   height: 100%!important;
 }

 .endeless-table-container {
   padding: 10px;
 }

 .leads-queue-wrapper {
   padding: 0px;
   position: absolute;
   height: 100%;
 }

 .leads-queue.full-height {
   position: absolute;
   height: 100%;
   width: 100%;
 }

 #dashboard-canvas {
   display: flex;
   flex-direction: column;
 }

 .ls-charts {
   flex: 100vh;
   flex-grow: 1;
   width: 100%;
   overflow: hidden;
   position: relative;
   margin: 0px!important;

   .chart-wrapper {
     height: 40vh;
     margin: 0;
   }
 }

 .ls-leads-table {
   display: flex;
   padding: 0px;
   position: relative;
   margin: 0px!important;
 }

 .with-leads-table .ls-charts {
   height: calc(100vh - 112px);
 }

 .with-leads-table.with-leads-table-active .ls-charts {
   height: 100%;
   flex-grow: 1;
   flex-basis: 35%;
   padding-bottom: 20px;
 }

 .with-leads-table.with-leads-table-active .ls-leads-table {
   height: 100%;
   flex-grow: 1;
   flex-basis: 65%;
 }

 .ls-charts-wrapper {
   position: absolute;
   height: calc(100% - 60px);
   overflow-y: auto;
   padding-bottom: 200px;
 }

 .ls-charts h1 {
   margin-left: 10px;
   margin-right: 10px;
 }

 .ls-charts > h4 {
   margin-top: -20px;
   margin-left: 30px;
   margin-right: 30px;
   padding: 5px 10px;
   background-color: #f5f5f5;
   border: #e3e3e3;
   border-radius: 0px 0px 4px 4px;
 }

 #dashboard-canvas h1 form {
   display: inline-block;
   width: 100%;
   height: 20px;
 }

 #dashboard-canvas h1 input[type="text"] {
   background-color: #efefef;
   display: inline-block;
   width: 90%;
 }

 .vue-grid-placeholder {
   background-color: #333!important;
   border-radius: 4px 4px 4px 4px;
 }

 .metrics-banner-text {
   font-size: 1.8em;
   font-weight: 600;
   color: #ff7a7c;
 }

 .ls-charts > .row {
   margin: 0px;
 }

 .box {

   padding: 10px;
 }

</style>



// WEBPACK FOOTER //
// Policies.vue?08cc4049